import { render, staticRenderFns } from "./SourceTitleSetupView.vue?vue&type=template&id=b3a3ce50&scoped=true&"
import script from "./SourceTitleSetupView.vue?vue&type=script&lang=ts&"
export * from "./SourceTitleSetupView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3a3ce50",
  null
  
)

export default component.exports